export class LanguageLang {
    public Language: {
        en: string;
        es: string;
        fr: string;
    };
}


// WEBPACK FOOTER //
// ./src/resources/LanguageLang.ts